import React from "react";
import '../css/Privacy.css'

const Privacy=()=>{
    return(
        <div className={'flex__center privacy-container'}>
            <div className={"contents-title-background-box"}>
                <div className={'red-dot-box'}>
                    <div className={'red-dot'}/>
                </div>
                <h3>개인정보 처리방침</h3>
            </div>
            <div className={'flex__center privacy-line-box'}>
                제주앙은(는) 이용자들의 개인정보보호를 매우 중요시하며, 이용자가 회사의 서비스를 이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고 있습니다. 이에 회사는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한 개인정보보호지침을 준수하고 있습니다. 회사는 개인정보 처리방침을 통하여 이용자들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려 드립니다.<br/><br/>

                회사는 개인정보 처리방침을 홈페이지 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다. 개인정보처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 처리방침의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하는 경우나 개인정보 처리방침 변경될 경우 쇼핑몰의 첫페이지의 개인정보처리방침을 통해 공지하고 있습니다.<br/>
                개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다. 이용자들께서는 사이트 방문 시 수시로 확인하시기 바랍니다.<br/><br/>
                개인정보 처리방침은 다음과 같은 내용을 담고 있습니다.<br/>
            </div>
            <div className={'flex__center privacy-non-line-box'}>
                1. 수집하는 개인정보의 항목 및 수집방법<br/>
                2. 개인정보의 수집 및 이용목적<br/>
                3. 개인정보의 보유 및 이용기간<br/>
                4. 개인정보의 파기 절차 및 방법<br/>
                5. 개인정보의 제3자 제공<br/>
                6. 이용자 및 법정대리인의 권리와 그 행사방법<br/>
                7. 쿠키(cookie)의 운영에 관한 사항<br/>
                8. 개인정보관리책임자 및 담당자의 연락처<br/>
                9. 고지의 의무<br/><br/>
                <b>1. 수집하는 개인정보의 항목 및 수집방법</b>
                회원가입, 비회원 구매, 상담, 불량이용의 방지 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br/>
                - 필수항목 : 성명, ID, 비밀번호, 생일/성별, 이메일, 연락처(휴대폰), 주소, 결제기록<br/>
                - 선택항목 : 개인맞춤 서비스를 제공하기 위하여 회사가 필요로 하는 정보<br/>
                - 수집방법 : 홈페이지<br/>
                <b>2. 개인정보의 수집 및 이용목적</b>
                수집한 개인정보는 다음의 목적을 위해 활용합니다.<br/>
                가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융서비스<br/>
                나. 성명 , 아이디, 비밀번호: 회원제 서비스 이용에 따른 본인 확인 절차에 이용<br/>
                - 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등 고객 민원처리, 고지사항 전달<br/>
                다. 서비스 및 이벤트 제공<br/>
                - 이메일주소, 전화번호 : 고지사항 전달, 불만처리, 부가서비스 등을 위한 원활한 의사소통 경로의 확보, 새로운 서비스 및 신상품이나 이벤트 정보 등의 안내<br/>
                - 이름, 핸드폰번호 : 이벤트진행을 위해 이름, 핸드폰번호가 저장되어 이용됨.<br/>
                라. 결제처리<br/>
                - 은행계좌정보, 신용카드정보 : 서비스 및 부가 서비스 이용에 대한 요금 결제<br/>
                - 주소, 전화번호 : 청구서, 물품배송시 정확한 배송지의 확보<br/>
                - 기타 선택항목 : 개인맞춤 서비스를 제공하기 위한 자료<br/>
                마. 부정이용 방지<br/>
                - IP Address : 불량회원의 부정 이용 방지와 비인가 사용 방지<br/>
                <b>3. 개인정보의 보유 및 이용기간</b>
                회원탈퇴 또는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지제 없이 파기합니다. 다만, 서비스의 부정/불량이용자의 재가입 방지를 위해 해지 후 3개월간 보유할 수 있으며 전자상거래에서의 소비자보호에 관한법률 등 타 법률에 의해 보존의무가 있는경우에는 볍령이 지정한 일정기간 보존합니다.<br/>
                <b>4. 개인정보의 파기 절차 및 방법</b>
                회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.<br/>
                가. 파기절차 이용자가 서비스 이용 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.<br/>
                나. 파기방법<br/>
                - 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각<br/>
                - 전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제, 데이터베이스 삭제<br/>

                <b>5. 개인정보의 제3자 제공</b>
                고객님의 개인정보를 회원가입 시 아래와 같이 고지 또는 명시하여 동의 받은 경우에 한하여 제3자에게 제공하고 있습니다. 회사는 이용자들의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br/>
                이용자들이 사전에 공개에 동의한 경우 정보수집 또는 정보제공 이전에 회원님께 비즈니스 파트너가 누구인지, 어떤 정보가 왜 필요한지, 그리고 언제까지 어떻게 보호 및 관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 회원님께서 동의하지 않는 경우에는 추가적인 정보를 수집하거나 비즈니스 파트너와 공유하지 않습니다.<br/>
                - 홈페이지에 게시한 서비스 이용 약관 및 기타 회원 서비스 등의 이용약관 또는 운영원칙을 위반한 경우<br/>
                - 자사 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우<br/>
                - 기타 법에 의해 요구된다고 선의로 판단되는 경우 (ex. 관련법에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등)<br/>
                <b>6. 이용자 및 법정대리인의 권리와 그 행사방법</b>
                회원님이 원하실 경우 언제라도 당사에서 개인정보를 열람하실 수 있으며 보관된 필수 정보를 수정하실 수 있습니다. 또한 회원 가입 시 요구된 필수 정보 외의 추가 정보는 언제나 열람, 수정, 삭제할 수 있습니다. 회원님의 개인정보 변경 및 삭제와 회원탈퇴는 당사의 고객센터에서 로그인(Login) 후 이용하실 수 있습니다.<br/>
                가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.<br/>
                나. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.<br/>
                다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.<br/>
                라. 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.<br/>

                <b>7. 개인정보관리책임자 및 담당자의 연락처</b>
                당사는 귀하가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 경우 개인정보관리 책임자가 책임을 집니다. 이용자 개인정보와 관련한 아이디(ID)의 비밀번호에 대한 보안유지책임은 해당 이용자 자신에게 있습니다. 회사는 비밀번호에 대해 어떠한 방법으로도 이용자에게 직접적으로 질문하는 경우는 없으므로 타인에게 비밀번호가 유출되지 않도록 각별히 주의하시기 바랍니다.<br/>
                특히 공공장소에서 온라인상에서 접속해 있을 경우에는 더욱 유의하셔야 합니다.<br/>
                회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보 관리책임자 및 담당자를 지정하고 있고, 연락처는 아래와 같습니다.<br/>

                개인정보관리책임자<br/>
                제주앙 임창범<br/>
                전화번호 : 0507-1352-6572<br/>

                개인정보시스템관리(수탁자:DB관리)<br/>
                이　　　 름　: 고흐아트<br/>
                소속 / 직위　: 개발팀,유지보수팀<br/>
                E-M A I L　 : jisang8255@naver.com<br/>

                가. 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.<br/>
                나. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.<br/>
                다. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.<br/>
                - 개인분쟁조정위원회 (www.1336.or.kr / 1336)<br/>
                - 정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)<br/>
                - 대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr / 02-3480-3600)<br/>
                - 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)<br/>

                <b>8. 고지의 의무</b>
                현 개인정보처리방침은 2014년 01월 01일부터 적용됩니다. 현 개인정보처리방침의 내용은 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을 시에는 홈페이지의 '공지사항'을 통해 고지할 것입니다.<br/>
            </div>
        </div>
    );
}

export default Privacy
